import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal, Link } from '@express-labs/raven-ui';
import { FORGOT_PASSWORD_FORM, LOGIN_FORM } from '../../constants';
import LoginFormVM from './components/LoginForm/index';
import ForgotPasswordFormVM from './components/ForgotPasswordForm/index';
import SlotNotificationAuthorable from '../../components/SlotNotificationAuthorable';
import ExpInsiderLogo from './ExpInsiderLogo';

import s from './LoginContainer.scss';

export default function LoginContainer(props) {
  const {
    firstBtnPath,
    formView,
    isModalOpen,
    loginStatus,
    onModalClose,
    setFormView,
  } = props;

  const handleClick = useCallback(() => {
    window.location.assign(firstBtnPath);
  }, [firstBtnPath]);
  if (loginStatus) return null;
  return (
    <Modal isOpen={isModalOpen} className={s.loginContainerModal} onModalClose={onModalClose}>
      {formView === LOGIN_FORM && (
        <div className={s.loginContainer}>
          <span className={[s.icon, s.svgInsiderContainer].join(' ')}>
            <SlotNotificationAuthorable currentPage="login" slot={2} />
            <ExpInsiderLogo />
          </span>
          <p className={s.signInTitle}>{props.descriptionText}</p>
          <LoginFormVM />
          <div className={s.forgotPassword}>
            <Link
              as="button"
              size="body"
              theme="dark"
              onClick={setFormView}
            >
              Forgot Password
            </Link>
          </div>
          <div className={s.notMember}>
            <SlotNotificationAuthorable currentPage="login" slot={4} />
            <span className="bodySecondary">Not an Insider?</span>
            <Link
              as="button"
              size="body"
              theme="dark"
              onClick={handleClick}
              className={s.joinForFree}
            >
              Join for Free
            </Link>
          </div>
        </div>
      )}
      {formView === FORGOT_PASSWORD_FORM && (
        <ForgotPasswordFormVM handleCurrentForm={setFormView} />
      )}
    </Modal>
  );
}

LoginContainer.propTypes = {
  isModalOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  firstBtnPath: PropTypes.string,
  formView: PropTypes.string,
  loginStatus: PropTypes.bool,
  descriptionText: PropTypes.string,
  setFormView: PropTypes.func,
};

LoginContainer.defaultProps = {
  isModalOpen: false,
  onModalClose: null,
  firstBtnPath: '/register',
  formView: LOGIN_FORM,
  loginStatus: false,
  descriptionText: '',
  setFormView: null,
};
